module.exports = __webpack_public_path__ + "img/icon_plain_1.c5d85011.svg";